import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[validateEqual][formControlName],[validateEqual][formControl],[validateEqual][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidatorDirective), multi: true }
    ]
})
export class EqualValidatorDirective implements Validator {

    // Class definitions
    constructor(@Attribute('validateEqual') public validateEqual: string,
        @Attribute('reverse') public reverse: string) {
    }

    // Reverse function, not being used right now I think
    private get isReverse() {
        if (!this.reverse) return false;
        return this.reverse === 'true' ? true : false;
    }

    // Check if the values match
    validate(c: AbstractControl): { [key: string]: any } {

        // Self value
        let v = c.value;

        // Control vlaue
        let e = c.root.get(this.validateEqual);

        // Value not equal
        if (e && v !== e.value && !this.isReverse) {
            return {
                validateEqual: false
            }
        }

        // Value equal and reverse
        if (e && v === e.value && this.isReverse) {
            delete e.errors!['validateEqual'];
            if (!Object.keys(e.errors!).length) e.setErrors(null);
        }

        // Value not equal and reverse
        if (e && v !== e.value && this.isReverse) {
            e.setErrors({ validateEqual: false });
        }
        return null!;
    }
}